import { Component, OnInit } from '@angular/core';
import { ReportesfService } from '../../../../services/fondeadores-reportes/reportesf.service';
import { ProductosFinancierosService } from '../../../../services/productos-financieros.service';
import { SucursalesService } from '../../../../services/sucursales.service';
import { DatesHelpersService } from '../../../../services/tools/dates-helpers.service';
import { HelpersService } from '../../../../services/tools/helpers.service';
import { ReportsHelperService } from '../../../../services/tools/reports-helpers.service';

@Component({
  selector: 'app-rendimientos-a-pagar',
  templateUrl: './rendimientos-a-pagar.component.html',
  styleUrls: ['./rendimientos-a-pagar.component.scss']
})
export class RendimientosAPagarComponent implements OnInit {

  public reportData: any [] = [];
  public totales: any = {};
  public tipoProductosSelected: any = '';
  public tiposProductos: any[] = [];
  //Filtros
  public search: any
  public fechaFin: string = null;
  public fechaInicio: string = null;
  //Helpers
  public isLoading: boolean = true;
  public isItemsArrayEmpty: boolean = null;

  public sucursales: any[] = [];
  public sucursal: any = {id:null};
  public sucursalPorDefecto: string = "";

  constructor(
    private helperService: HelpersService,
    private reportesService: ReportesfService,
    private dateshelper: DatesHelpersService,
    public helper: ReportsHelperService,
    private productosService: ProductosFinancierosService,
    private sucursalesService : SucursalesService
  ) { }

  ngOnInit() {
    this.setupDefaultState();
  }

  private setupDefaultState() {
    let temporal = this.dateshelper.getMonthDate();
    this.fechaFin = temporal.fechaFin;
    this.fechaInicio = temporal.fechaInicio;
    this.getTiposProductos();
    this.getSucursales();
    this.updateReporte();
  }


  private getSucursales(){
    this.isLoading = true;
    this.sucursalesService.get().subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.sucursales = jsonResult.content.data;
          if (this.sucursales.length>1){
            this.sucursalPorDefecto = "Seleccione";
          } else if(this.sucursales.length>0){
            this.sucursal =  this.sucursales[0];
          }
          // this.updateReporte(); //Para actualizar la tabla
          this.isLoading = false; 
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  private getTiposProductos(){
    this.productosService.getSelect().subscribe(
        (response)=>
        {
            const jsonResult = response.json();
            if(jsonResult.content){
                this.tiposProductos = jsonResult.content;
            }
        }, error =>
        {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
        }
    );
  }

  sucursalChanged(sucursal){
      if(sucursal){
      this.sucursal = sucursal;
      this.updateReporte(); //Para actualizar la tabla
      }
  }

  public onChangeTipoProducto(){
    this.updateReporte(); //Para actualizar la tabla
  }

  public print(){
    //Imprimir pantalla
    window.print();
  }

  public descargar(){
    let filters = {
      fechaInicio: this.fechaInicio,
      fechaFin: this.fechaFin,
      tipoProducto: this.tipoProductosSelected,
      sucursal : this.sucursal.id,
      search: this.search
    }

    this.reportesService.reporte2ToExcel(filters).subscribe(
      (response)=>{
        const fileUrl = window.URL.createObjectURL(response.blob());
        //Muestra el archivo en una nueva ventana
        window.open(fileUrl);
      }, async error =>{
        // se resuelve error 403 y 500
        const imagen_response = await fetch(error);
        const imagen_blob = await imagen_response.blob();
        let fr = new FileReader()
        fr.onload = function(e) {
            console.log(e)
        };
        
        fr.readAsText(imagen_blob);
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
  );

  }
  
  public updateReporte(){

    let filters = {
        fechaInicio: this.fechaInicio,
        fechaFin: this.fechaFin,
        tipoProducto: this.tipoProductosSelected,
        sucursal : this.sucursal.id,
        search: this.search
    }

    //Mostrar el ajax loading
    this.isLoading = true;

    this.reportesService.reporte2(filters).subscribe(
        (response)=>
        {
            const jsonResult = response.json();
            let items = [];
            let totales = {};
            if(jsonResult.content ){
              console.log(jsonResult.content)
              items = jsonResult.content.data;
            }

            this.reportData = items;
            this.totales = jsonResult.content.totales;
            this.isLoading = false;
            this.isItemsArrayEmpty = this.reportData.length == 0;
        }, error =>
        {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        }
    );
  }
  public CalcularTotales(){
    this.totales.monto_pagado = 0;
    for (let index = 0; index < this.reportData.length; index++) {
      const element = this.reportData[index];
      this.totales.monto_pagado += element.monto_saldo
    }
    console.log(this.totales);
  }

}




// WEBPACK FOOTER //
// ./src/app/administracion/fondeadores/reporteria/rendimientos-a-pagar/rendimientos-a-pagar.component.ts